import React, { useEffect, useState } from "react";
//helemt
import { Helmet } from "react-helmet-async";
// locale
import { useLocales } from "../../locales";
// form
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
// @mui
import {
  Alert,
  Box,
  IconButton,
  InputAdornment,
  Stack,
  Grid,
  Typography,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
// auth
import { useAuthContext } from "../../auth/useAuthContext";
// components
import FormProvider, { RHFTextField } from "../../components/hook-form";
import Iconify from "../../components/iconify";
// Section Components
import ImageSection from "../../section/auth/ImageSection";
import ChangeLanguageBox from "../../section/auth/details/ChangeLanguageBox";
// //toast
// import { toast } from "react-toastify";
// -----------------------------------------------------------------------------

//* ------- Styles --------
const txtFieldBorderStyle = {
  width: "100%",
  paddingBottom: "24px",
  "& .MuiFormLabel-root": {
    color: "#BCBCBC",
    fontSize: "16px",
  },
  "& .MuiOutlinedInput-root": {
    height: '48px',
    fontSize: '14px',
    color: '#535353',
    "& fieldset": {
      borderRadius: "4px",
      borderColor: "#ECECEC",
    },
    "&:hover fieldset": {
      border: "1px solid #ECECEC",
    },
    "&.Mui-focused fieldset": {
      border: "1px solid",
      borderColor: "primary.main",
    },
  },
  "& .MuiFormHelperText-root ": {
    fontSize: '12px'
  },
  "& .MuiSelect-select ": {
    display: 'flex'
  },
};

const labelSx = {
  fontSize: "14px",
  fontWeight: "400",
  lineHeight: "12px",
  color: "#535353",
  width: '100%',
  textAlign: 'left'
};

const loadingButtonStyle = {
  marginBottom: "23px",
  fontSize: "16px",
  fontWeight: 600,
  bgcolor: "#FFC801",
  // bgcolor: "#2E2857",
  py: "15px",
  color: (theme) => (theme.palette.mode === "light" ? "#EBF4F8" : "grey.800"),
  "&:hover": {
    bgcolor: "text.primary",
    color: (theme) =>
      theme.palette.mode === "light" ? "common.white" : "grey.800",
  },
  "&:focus": {
    bgcolor: "#fba900",
    color: "#FFFFFF",
  },
  marginLeft: "auto",
  borderRadius: "6px",
  marginRight: "auto",
  boxShadow:
    " 0px 2px 4px rgba(44, 39, 56, 0.08), 0px 4px 8px rgba(44, 39, 56, 0.08)",
};

const holder = {
  position: "relative",
  p: {
    xs: "0px 0px",
    sm: "00px 0px",
    md: "00px 50px",
    lg: "0px 100px 0px 100px ",
  },
};

const inputsHolderSx = {
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
  textAlign: "center",
  alignItems: "center",
};

const imageSectionSx = {
  display: {
    xs: "none",
    md: "block",
  },
};

export default function LoginPage() {

  const { login } = useAuthContext();

  useEffect(() => {
    localStorage.clear();
  }, []);

  const [showPassword, setShowPassword] = useState(false);

  const { translate } = useLocales();

  const SignInSchema = Yup.object().shape({
    username: Yup.string().required(translate("username_is_required")),
    password: Yup.string().required(translate("password_is_required")),
  });

  const defaultValues = {
    username: "",
    password: "",
  };

  const methods = useForm({
    mode: 'onChange',
    resolver: yupResolver(SignInSchema),
    defaultValues,
  });

  const {
    reset,
    // setError,
    handleSubmit,
    formState: { errors, isSubmitting, isSubmitSuccessful },
  } = methods;

  const onSubmit = async (data) => {
    try {
      if (login) {
        await login(data);
      }
    } catch (error) {
      reset();
    }
  };
  // ------------- JSX Code ----------
  return (
    <>
      <Helmet>
        <title>{translate('login_page')}</title>
      </Helmet>

      <Grid container height="100%">

        {/* ********************* Login Form Section ******************/}


        <Grid item xs={10} sm={8} md={6} mx="auto">

          {/* __________ Langauge Changer  _________ */}
          <ChangeLanguageBox />

          {/* __________________ Login Form page ____________ */}
          <Stack sx={{ ...holder, justifyContent: "center", height: "100%" }}>
            {/* _____ Head of login page ____ */}
            <Stack mb="23px">
              {/*---- logo ---- */}
              <Stack direction="row" justifyContent="center" mb="28px">
                <img src="/assets/images/logo/logo.png" alt="logo" />
              </Stack>
            </Stack>

            {/*----------------- Form of login page -------------- */}
            <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
              <Box sx={{ ...inputsHolderSx }}>
                {!!errors.afterSubmit && (
                  <Alert severity="error">{errors.afterSubmit.message}</Alert>
                )}

                {/*------ username input -------- */}
                {/* <RHFTextField
                  name="username"
                  label={translate("username")}
                  type="username"
                  sx={{ ...txtFieldBorderStyle }}
                /> */}

                <Typography sx={{ ...labelSx, mb: '8px' }}>
                  {translate("username")}
                </Typography>
                <RHFTextField
                  name="username"
                  placeholder="Sch00ly415"
                  sx={{
                    ...txtFieldBorderStyle,
                    width: "100%",
                  }}
                />




                <Typography sx={{ ...labelSx, mb: '8px' }}>
                  {translate("password")}
                </Typography>
                {/*------ password input -------- */}
                <RHFTextField
                  name="password"
                  // label={translate("password")}
                  type={showPassword ? "text" : "password"}
                  sx={txtFieldBorderStyle}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => setShowPassword(!showPassword)}
                          edge="end"
                        >
                          <Iconify
                            icon={
                              showPassword
                                ? "eva:eye-outline"
                                : "eva:eye-off-outline"
                            }
                            color={showPassword ? "#FFCC63" : "#BCBCBC"}
                            width='25px'
                          />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Box>

              {/* -------- Submit Button and sign ip link --------- */}
              <Stack sx={{ marginX: "auto" }}>
                {/* --- Next Button --- */}
                <LoadingButton
                  fullWidth
                  disableRipple
                  size="large"
                  type="submit"
                  variant="Contained"
                  sx={{
                    ...loadingButtonStyle,
                  }}
                  loading={isSubmitting}
                >
                  {translate("sign_in")}
                </LoadingButton>
              </Stack>
            </FormProvider>
          </Stack>
        </Grid>

        {/* ************ image Section ************/}
        <Grid item sm={6} sx={{ ...imageSectionSx }}>
          <ImageSection height={657} />
        </Grid>
      </Grid>
    </>
  );
}
